import { render, staticRenderFns } from "./RecipientIpaAddressEditForm.vue?vue&type=template&id=0d7e005c&"
import script from "./RecipientIpaAddressEditForm.vue?vue&type=script&lang=js&"
export * from "./RecipientIpaAddressEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports